import { Component, Inject } from '@angular/core';
import {
  MatDialog,
  MatDialogRef,
  MatDialogActions,
  MatDialogClose,
  MatDialogTitle,
  MatDialogContent,
  MAT_DIALOG_DATA,
} from '@angular/material/dialog';
import { AppConfigService } from 'src/app/Services/app-config.service';
//import { MAT_ICON_DEFAULT_OPTIONS, MatIcon } from '@angular/material/icon';

@Component({
  selector: 'app-entertainment-dialog',
  templateUrl: './entertainment-dialog.component.html',
  styleUrls: ['./entertainment-dialog.component.css'],
})
export class EntertainmentDialogComponent {
  imagepath = '';
  //public alertMessage: string = 'test';
  constructor(
    private appConfigService: AppConfigService,
    public dialogRef: MatDialogRef<EntertainmentDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    this.imagepath = this.appConfigService.imagepath;
  }
  clickclose(): void {
    this.dialogRef.close();
  }
}
